import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { RuleSlice, EditRule, SavedRule, Status } from './types';
import { getRules, saveRule } from '../../api/rules';
import { MenuNodeSlice } from '../positions/types';
import moment from 'moment';
import { setTemporaryMessage } from './settingsSlice';
import { isUndefined, notUndefined } from '../../lib/typeCheck';

const initialState: RuleSlice[] = [];

export const rulesSlice = createSlice({
  name: 'rules',
  initialState,
  reducers: {
    loadRules: (state, action: PayloadAction<RuleSlice[]>) => {
      return action.payload;
    },
    editRule: (state, action: PayloadAction<EditRule>) => {
      const rule = state.find(rule => rule.id === action.payload.id)
      
      if (notUndefined(action.payload.title)) rule.title = action.payload.title;    
      if (notUndefined(action.payload.description)) rule.description = action.payload.description;
      if (notUndefined(action.payload.category)) rule.category = action.payload.category;
      if (notUndefined(action.payload.station_id)) rule.station_id = action.payload.station_id;
      if (notUndefined(action.payload.schedules_id)) rule.schedules_id = action.payload.schedules_id;
      if (notUndefined(action.payload.status)) rule.status = action.payload.status;
      if (notUndefined(action.payload.meta)) rule.meta = action.payload.meta;
      if (notUndefined(action.payload.wrx_option_id)) rule.wrx_option_id = action.payload.wrx_option_id;
      
      rule.saved = false;
      if (typeof action.payload.saved != 'undefined') {
        rule.saved = action.payload.saved;
      }
    },
    loadSavedRule: (state, action: PayloadAction<{ savedRule: SavedRule; selectedNodes?: Array<MenuNodeSlice>; }>) => {     
        
      let next_id = 1;
      if (state.length > 0) {
        next_id = state[state.length - 1].id + 1;
      }
      
      const { savedRule, selectedNodes } = action.payload;
      
      let rule = {
        id: next_id,
        rule_id: savedRule.id,
        account_id: savedRule.account_id,
        station_id: parseInt(selectedNodes[0].id),
        schedules_id: savedRule.schedules_id,
        category: savedRule.category,
        title: savedRule.title,
        description: '',
        status: 1,
        meta: savedRule.meta,
        saved: true,
        wrx_option_id: savedRule.wrx_option_id
      }
      
      state.push(rule);
    },
    newRule: (state, action: PayloadAction<{ newRule: EditRule; selectedNodes?: Array<MenuNodeSlice>; }>) => {
        
      let next_id = 1;
      if (state.length > 0) {
        next_id = state[state.length - 1].id + 1;
      }
      
      const { newRule, selectedNodes } = action.payload;
      
      let rule = {
        id: next_id,
        rule_id: null,
        account_id: newRule.account_id,
        station_id: parseInt(selectedNodes[0].id),
        schedules_id: null,
        category: newRule.category,
        title: newRule.title,
        description: '',
        status: 1,
        meta: newRule.meta,
        saved: false,
        wrx_option_id: newRule.wrx_option_id
      }
      
      state.push(rule);
    },    
  },
});

export const { loadRules, loadSavedRule, editRule} = rulesSlice.actions;

export const fetchRules = (): AppThunk => async (dispatch, getState) => {
  const { rules, user, menuNodes } = getState()
  
  var station_id = null;
  let stations = menuNodes.filter((node) => node.selected && node.type == 'station')
  if (stations.length == 0) {
    return;
  } else {
    station_id = stations[0].id;
  }
  
  try {
    const rules = await getRules(user.api_key, station_id, 'all')
    const refinedRules: RuleSlice[] = prepareRulesForStore(rules);
    
    dispatch(loadRules(refinedRules));
  } catch (err) {
    console.error(err.toString())
  }
};

export const prepareRulesForStore = (rules) => {
  
  return rules.map((rule, index) => {
    return {
      id: index,
      rule_id: parseInt(rule.rule_id),
      account_id: parseInt(rule.account_id),
      station_id: parseInt(rule.station_id),
      schedules_id: parseInt(rule.schedules_id),
      category: rule.category,
      title: rule.title,
      description: rule.description,
      status: parseInt(rule.status),
      meta: rule.meta,
      saved: true,
      wrx_option_id: parseInt(rule.wrx_option_id)
    }
  })
}

// export const updateRule = (station_ids: number[], schedules_id: number, category: string): AppThunk => async (dispatch, getState) => {
  // const { user } = getState()
  // 
  // try {
  //   const schedules = await attachStations(user.api_key, station_ids, schedules_id, category);
  //   // dispatch(fetchStation(station_ids[0]));
  // } catch (err) {
  //   console.error(err.toString())
  // }
// };

export const removeRule = (rule: EditRule): AppThunk => async (dispatch, getState) => {
  // const { user } = getState()
  // 
  // if (schedule.schedules_id === null) {
  //   dispatch(removeSchedule(schedule));
  //   return;
  // }
  // 
  // try {
  //   const schedules = await detachStations(user.api_key, schedule.station_ids, schedule.schedules_id, schedule.category);
  //   dispatch(removeSchedule({id: schedule.id}));
  //   // dispatch(fetchStation(schedule.station_ids[0]));
  // } catch (err) {
  //   dispatch(setTemporaryMessage('Failed to remove'));
  // 
  // }
};

export const saveRuleToDb = (rule: EditRule): AppThunk => async (dispatch, getState) => {
  const { user } = getState()
  
  try {
   
    const result = await saveRule(user.api_key, user.account.id, {
      rule_id: rule.rule_id,
      station_id: rule.station_id,
      schedules_id: rule.schedules_id,
      category: rule.category,
      title: rule.title,
      description: rule.description,
      status: rule.status,
      meta: rule.meta,
      wrx_option_id: rule.wrx_option_id,
    });
  
    dispatch(editRule({id: rule.id, status: rule.status, saved: true}));
    // dispatch(setTemporaryMessage('Saved'));
  } catch (err) {
    dispatch(setTemporaryMessage('Failed to save'));
    console.log(err);
  }
};

export const saveRulesToDb = (rules: EditRule[]): AppThunk => async (dispatch, getState) => {
  const { user } = getState()
  
  rules.forEach(rule => {
    if (!rule.saved) {
      dispatch(saveRuleToDb(rule));
    }
  })
};

export const selectAllRules = (state: RootState) => {
  return state.rules;
};

export const selectFilteredRules = (category: string) => (state: RootState) => {
  return state.rules.filter(rule => rule.category === category && rule.status === Status.ACTIVE);
};

export default rulesSlice.reducer;
